import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";
import { NAV, SEDI, CONFIG, whatsappLink } from "@/data/content";

const Footer = () => (
  <footer className="bg-navy-900 text-white relative" data-testid="site-footer">
    <div className="absolute inset-0 noise-overlay opacity-[0.04] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Logo light />
          <p className="mt-5 text-sm text-white/70 leading-relaxed">
            Al fianco del personale scolastico ogni giorno: consulenza sindacale, assistenza nelle procedure, formazione, CAF e Patronato.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={CONFIG.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-gold-500 hover:text-gold-500 transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href={CONFIG.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-gold-500 hover:text-gold-500 transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href={CONFIG.social.youtube} target="_blank" rel="noreferrer" aria-label="YouTube" className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-gold-500 hover:text-gold-500 transition-colors"><Youtube className="w-4 h-4" /></a>
            <a href={whatsappLink()} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-gold-500 hover:text-gold-500 transition-colors"><MessageCircle className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-gold-500 text-sm uppercase tracking-[0.2em] font-bold mb-5">Collegamenti</h4>
          <ul className="space-y-3 text-sm text-white/75">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="hover:text-gold-400 transition-colors">{n.label}</Link></li>
            ))}
            <li><Link to="/area-assistiti" className="hover:text-gold-400 transition-colors">Area Assistiti</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-gold-500 text-sm uppercase tracking-[0.2em] font-bold mb-5">Sedi</h4>
          <ul className="space-y-4 text-sm text-white/75">
            {SEDI.map((s) => (
              <li key={s.city} className="flex gap-3">
                <MapPin className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" />
                <span><span className="text-white font-semibold">{s.city}</span><br />{s.address}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-gold-500 text-sm uppercase tracking-[0.2em] font-bold mb-5">Contatti</h4>
          <ul className="space-y-4 text-sm text-white/75">
            <li className="flex gap-3"><Phone className="w-4 h-4 text-gold-500 shrink-0" /><a href={CONFIG.phoneHref} className="hover:text-gold-400 transition-colors">{CONFIG.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-gold-500 shrink-0" /><a href={`mailto:${CONFIG.email}`} className="hover:text-gold-400 transition-colors">{CONFIG.email}</a></li>
            <li className="flex gap-3"><MessageCircle className="w-4 h-4 text-gold-500 shrink-0" /><a href={whatsappLink()} target="_blank" rel="noreferrer" className="hover:text-gold-400 transition-colors">WhatsApp</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/55">
        <p>© {new Date().getFullYear()} Palumbo Academy — {CONFIG.piva}</p>
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <a href="#" className="hover:text-gold-400 transition-colors">Privacy Policy</a>
          <a href="#" className="hover:text-gold-400 transition-colors">Cookie Policy</a>
          <a href="#" className="hover:text-gold-400 transition-colors">Termini e Condizioni</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
